import { Pivot, PivotItem } from "@fluentui/react";
import DOMPurify from "dompurify";
import styles from "./AnalysisPanel.module.css";
import { SupportingContent } from "../SupportingContent";
import { AskResponse } from "../../api";
import { AnalysisPanelTabs } from "./AnalysisPanelTabs";

interface Props {
    className: string;
    activeTab: AnalysisPanelTabs;
    onActiveTabChanged: (tab: AnalysisPanelTabs) => void;
    activeCitation: string | undefined;
    citationHeight: string;
    answer: AskResponse;
}

// Utilidad para reemplazar las citaciones en el texto
function renderThoughtsWithCitations(thoughts: string, dataPoints: string[]) {
    // Solo muestra el número de citación la primera vez que aparece cada [[CITATION_X]]
    const shownIndices = new Set<number>();
    return thoughts.replace(/\[\[CITATION_(\d+)\]\]/g, (match, indexStr) => {
        const index = Number(indexStr);
        if (dataPoints[index] && !shownIndices.has(index)) {
            // Primera vez que aparece esta citación, la mostramos
            shownIndices.add(index);
            return `<span class="citation-number">${index + 1}</span>`;
        }
        // Si ya la mostramos antes, la omitimos
        return "";
    });
}
export const AnalysisPanel = ({ answer, activeTab, activeCitation, citationHeight, className, onActiveTabChanged }: Props) => {
    const isDisabledCitationTab: boolean = !activeCitation;

    // Sanitiza y procesa los pensamientos/citaciones en el texto
    const sanitizedThoughts = DOMPurify.sanitize(renderThoughtsWithCitations(answer.thoughts ?? "", answer.data_points));

    return (
        <div className={styles.ModalContainer}>
            <Pivot
                className={className}
                selectedKey={activeTab}
                onLinkClick={pivotItem => pivotItem && onActiveTabChanged(pivotItem.props.itemKey! as AnalysisPanelTabs)}
            >
                <PivotItem
                    itemKey={AnalysisPanelTabs.CitationTab}
                    headerText="X"
                    headerButtonProps={isDisabledCitationTab ? { disabled: true, style: { color: "grey" } } : { style: { color: "white" } }}
                    className={styles.ITEMPIVOT}
                >
                    {/* Renderiza el texto con citaciones */}
                    <div dangerouslySetInnerHTML={{ __html: sanitizedThoughts }} />
                    {/* Citaciones al final */}
                    <div>
                        {answer.data_points.map((dp, idx) => (
                            <span key={idx} className="citation">
                                {idx + 1}. {dp}
                            </span>
                        ))}
                    </div>
                    <iframe title="Citation" src={activeCitation} width={"100%"} height={"100%"} />
                </PivotItem>
            </Pivot>
        </div>
    );
};
